import React from "react";

export default function MoodboardsGrid({ moodboards, dense = false }) {
  const items = moodboards || [];
  if (!items.length) return null;
  return (
    <section data-testid="moodboards-grid" className="py-16 md:py-28 border-t border-[color:var(--border)]">
      <div className="max-w-[1500px] mx-auto px-5 md:px-10">
        {!dense && (
          <div className="mb-10 md:mb-16">
            <div className="eyebrow mb-3">The Palette</div>
            <h2 className="font-display italic text-4xl md:text-6xl leading-[1] tracking-tight">Moodboards</h2>
            <p className="mt-4 max-w-lg text-sm text-[color:var(--text-muted)]">
              Studies in colour, texture and light — how each wedding begins on paper.
            </p>
          </div>
        )}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-3">
          {items.map((m, i) => {
            const isWide = i % 5 === 2;
            const isTall = i % 5 === 0;
            return (
              <figure
                key={m.id}
                data-testid={`moodboard-${m.id}`}
                className={`hover-scale bg-[color:var(--surface)] ${isTall ? "row-span-2 aspect-[3/4]" : isWide ? "md:col-span-2 aspect-[16/10]" : "aspect-square"}`}
              >
                <img src={m.image_url} alt={m.title} loading="lazy" className="w-full h-full object-cover" />
              </figure>
            );
          })}
        </div>
      </div>
    </section>
  );
}
